/* "Nirvik Ready for companies and teams" (/guides/companies): its own opening, ideas and playbook around the shared chapters. */
import why from './why.md?raw';
import ideas from './ideas.md?raw';
import playbook from './playbook.md?raw';
import { audienceGuide } from '../audience';

export const companiesGuide = audienceGuide({
  audience: 'companies',
  title: 'Nirvik Ready for companies and teams',
  subtitle:
    'How companies run cyber and AI readiness for everyone, from awareness training people finish to secure building with AI.',
  reviewed: '2026-10-25',
  why: {
    title: 'Why Nirvik Ready for companies and teams',
    summary: 'Everyone, engineers, managers and your security team',
    markdown: why,
  },
  ideas: { summary: 'Awareness training, policies, engineering and webinars', markdown: ideas },
  playbook: { summary: 'Your first quarter, week by week', markdown: playbook },
});
